import { isWeb } from 'tamagui'
import { SessionProvider as WebSessionProvider } from '@contexts/WebSessionContext'
import { SessionProvider as AppSessionProvider } from '@contexts/AppSessionContext'

export function SessionProvider({ children }: { children: JSX.Element }) {
  if (isWeb) {
    return <WebSessionProvider>{children}</WebSessionProvider>
  }
  return <AppSessionProvider>{children}</AppSessionProvider>
}
